<script>
  import { onMount, afterUpdate } from "svelte";
  import { slide } from 'svelte/transition';
  import { stringify } from "query-string";
  import { apiCall, apiUpdate, apiCreate, notify } from "../httpCommon";
  import Contact from "./ContactEdit.svelte";
  import Card, { PrimaryAction, Content } from "@smui/card";
  import IconButton from "@smui/icon-button";

  export let path;
  export let filter = {};

  let data = [];
  let errors = {};
  let notifications = [];

  async function getContacts() {
    try {
      const query = {
        filter: JSON.stringify(filter)
      };
      const response = await apiCall(`${path}/users?${stringify(query)}`);
      data = await response.json();
    } catch (error) {
      errors = error.errors;
      notify(error);
    }
  }

  async function getNotifications() {
    try {
      const query = {
        filter: JSON.stringify(filter)
      };
      const response = await apiCall(`/notifications?${stringify(query)}`);
      notifications = await response.json();
    } catch (error) {
      notify(error);
    }
  }

  function add() {
    data = data.concat({ subscriptions: [] });
  }

  function remove(index) {
    const contact = data.splice(index, 1);
    data = data;
  }

  onMount(() => {
    getContacts();
    getNotifications();
  });

  $: showAdd = !data || data.filter(c => !c.id).length === 0;
</script>

<style>
  .title {
    display: flex;
    justify-content: space-between;
  }
  .contact {
    margin-bottom: 5px;
  }
</style>

{(console.log('contacts: ', data), '')}
<Card variant="outlined" padded color="error">
  <span class="title">
    <h3>Contacts</h3>
    {#if showAdd}
      <IconButton class="material-icons" on:click={add}>add</IconButton>
    {/if}
  </span>
  {#each data as row, i}
    <div class="contact" transition:slide|local>
      <Contact
        {path}
        bind:data={row}
        {notifications}
        id={row.id}
        on:deleted={() => remove(i)}
        on:reload={() => getContacts()} />
    </div>
  {/each}
</Card>
